import { render, staticRenderFns } from "./Funnels.vue?vue&type=template&id=788570e3&scoped=true"
import script from "./Funnels.vue?vue&type=script&lang=js"
export * from "./Funnels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788570e3",
  null
  
)

export default component.exports